export default [
  {
    path: '/admin/employees',
    name: 'em-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/employee/profile')
  },
  {
    path: '/admin/employees/create',
    name: 'em-profile-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/employee/profile/create')
  },
  {
    path: '/admin/employees/:id/edit',
    name: 'em-profile-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/employee/profile/edit')
  }
]
